import { ValueOf } from './util.type.ts';

export interface Localized<T> {
  kr: T;
  en: T;
  jp: T;
}

export const Lang = {
  kr: 'kr',
  en: 'en',
  jp: 'jp',
} as const;
export type Lang = ValueOf<typeof Lang>;
